export const processBusinessComparisons = async (
	musicalChairsPrompt: string[][],
	businessComparisonsHasChanged: boolean[],
	handleAiResponseClick: {
		(
			prompt: Array<Array<string>>,
			i: number,
			swapIndex?: number,
			isUserInitiated?: boolean
		): Promise<void>
		(
			arg0: Array<Array<string>>,
			arg1: number,
			arg2: number | undefined,
			arg3: boolean
		): unknown
	}
) => {
	for (let i = 0; i <= musicalChairsPrompt.length - 1; i++) {
		const comparison = musicalChairsPrompt[i][0]
		const expected = (i + 1).toString()

		const value =
			comparison !== expected ? parseInt(comparison, 10) : undefined
		await handleAiResponseClick(musicalChairsPrompt, i, value, false)
		businessComparisonsHasChanged[i] = false
	}
}

export const stringifyStages = (stages: Array<Array<string>>): string => {
	let stagesString = ''
	const stagesCopy = [...stages]
	// Sort to ensure we send in correct order to BE if a swap has been made
	stagesCopy.sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
	stagesCopy.forEach((stageArray) => {
		const stage = stageArray[0] + '.' + stageArray[1] + '\n'
		stagesString = stagesString + stage
	})
	return stagesString
}
